import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { useClassName } from '../../../../hooks';
import { Icon } from '../../../Icon/Icon';
import './Fetching.scss';
export const Fetching = ({ variant }) => {
    const className = useClassName({ name: 'button-fetching', prefixed: true }, 'fetching');
    const iconColor = useMemo(() => (variant === 'primary' ? 'white' : 'neutral-900'), [variant]);
    return (_jsx("div", { className: className, children: _jsx("div", { className: 'container fetching', children: _jsx(Icon, { name: 'spinner', color: iconColor, size: 'md' }) }) }));
};
